// src/components/internationalization/MultiCurrencySupport.js
import React, { createContext, useContext, useState } from 'react';

const CurrencyContext = createContext();

export const useCurrency = () => useContext(CurrencyContext);

const supportedCurrencies = {
  INR: { symbol: '₹', rate: 83.50 }, // Indian Rupee
  USD: { symbol: '$', rate: 1 },      // US Dollar
  EUR: { symbol: '€', rate: 0.92 },    // Euro
  GBP: { symbol: '£', rate: 0.79 },    // British Pound
};

export const CurrencyProvider = ({ children }) => {
  const [currency, setCurrency] = useState('INR');

  const convertPrice = (priceInUSD) => {
    const selectedCurrency = supportedCurrencies[currency];
    if (!selectedCurrency) {
      return { amount: priceInUSD, symbol: '$' }; // Default to USD
    }
    const convertedAmount = priceInUSD * selectedCurrency.rate;
    return {
      amount: convertedAmount.toFixed(2),
      symbol: selectedCurrency.symbol,
    };
  };

  const value = {
    currency,
    setCurrency,
    convertPrice,
    supportedCurrencies,
  };

  return (
    <CurrencyContext.Provider value={value}>
      {children}
    </CurrencyContext.Provider>
  );
};